module.exports = __webpack_public_path__ + "static/media/bildmarke_smokeless.90d0f05d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/bildmarke_smokeless.svg
// module id = 279
// module chunks = 0